import * as Sentry from '@sentry/browser';

/**
 * @param {object} error - takes an exception and logs to Sentry or the console in development
 * @param {object} [scope] - Sentry CaptureContext created with new Sentry.Scope() or plain object
 * @desc logger is designed for logging errors. It will accept an argument of any type and create a stacktrace containing a reference to the callee.
 * @TODO Migrate this functionality to a logging module that handles different levels of logs
 */
const logger = (error, scope) => {
    let sentryException;
    if (error instanceof Error) {
        sentryException = error;
    } else if (typeof error === 'string') {
        sentryException = new Error(error);
    } else {
        sentryException = new Error(JSON.stringify(error));
    }
    if (scope) {
        Sentry.captureException(sentryException, scope);
    } else {
        Sentry.captureException(sentryException);
    }
};

export default logger;
